export function fieldClassName (field, success = true) {
  // for bootstrap classes
  if (!field) {
    return ''
  }
  if ((field.$touched || field.$submitted) && field.$valid && success) {
    return 'has-success'
  }
  if ((field.$touched || field.$submitted) && field.$invalid) {
    return 'has-danger'
  }
}

export function parseError (response, asObject = false) {
  let error = ''
  let errors = []
  if (response.body !== null && typeof response.body === 'object') {
    if (response.body.message) {
      error = response.body.message
    }
    console.log(response.body)
    if (response.body.errors) {
      errors = response.body.errors
    }
  } else {
    error = response.statusText
  }
  console.log(error, errors)
  return asObject ? { message: error, errors: errors } : [error, errors]
}

export function params (object) {
  let params = []
  for (let key in object) {
    if (Array.isArray(object[key])) {
      object[key].forEach((v) => {
        params.push(key + '[]=' + v)
      })
    } else {
      params.push(key + '=' + object[key])
    }
  }
  return (params.length > 0) ? '?' + params.join('&') : ''
}

export class Converter {
  static objectToFormData (obj, form, namespace) {
    let fd = form || new FormData()
    let formKey

    for (let property in obj) {
      if (obj.hasOwnProperty(property)) {
        if (namespace) {
          formKey = namespace + '[' + property + ']'
        } else {
          formKey = property
        }

        // if the property is an object, but not a File,
        // use recursivity.
        if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
          this.objectToFormData(obj[property], fd, formKey)
        } else {
          // if it's a string or a File object
          fd.append(formKey, obj[property])
        }
      }
    }

    return fd
  }
}



// WEBPACK FOOTER //
// ./src/packages/Helpers.js